import React from "react";
import PropTypes from "prop-types";
import styles from "./StandingOrderIcon.module.css";

/**
 * View component. An icon for a Standing Order feed item.
 */
export function StandingOrderIcon({ iconType, iconSize }) {
  const ICON_MAP = {
    DR: "https://wwgusdev.blob.core.windows.net/icons/bsm-diamond-rally.png",
    DS: "https://wwgusdev.blob.core.windows.net/icons/bsm-diamond-seminar.png",
    DN: "https://wwgusdev.blob.core.windows.net/icons/bsm-dream-night.png",
    ER: "https://wwgusdev.blob.core.windows.net/icons/bsm-emerald-rally.png",
    FR: "https://wwgusdev.blob.core.windows.net/icons/bsm-family-reunion.png",
    FMA: "https://wwgusdev.blob.core.windows.net/icons/bsm-fma.png",
    FE: "https://wwgusdev.blob.core.windows.net/icons/bsm-free-enterprise.png",
    SP: "https://wwgusdev.blob.core.windows.net/icons/bsm-specialty.png",
    SL: "https://wwgusdev.blob.core.windows.net/icons/bsm-spring-leadership.png",
    "3P": "https://wwgusdev.blob.core.windows.net/icons/bsm-third-party.png",
    Compass: "https://wwgusdev.blob.core.windows.net/icons/bsm-true-north.png",
  };
  const FALLBACK = "https://wwgusdev.blob.core.windows.net/icons/bsm-third-party.png";

  const iconSrc = !iconType
    ? FALLBACK
    : iconType.startsWith("http")
    ? iconType
    : ICON_MAP[iconType] ?? FALLBACK;

  return (
    <>
      <div className={styles.iconDiv}>
        <img
          alt="Standing Order Icon"
          className={styles.icon}
          src={iconSrc}
          style={{ width: iconSize, height: iconSize }}
        />
      </div>
    </>
  );
}

StandingOrderIcon.propTypes = {
  iconType: PropTypes.string,
  iconSize: PropTypes.string,
};
